import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import './style.css'

const MovieTmdb = ({ movies, mediaType, showIndex })=> {

    const [ qualidadeImg, setQualidadeImg ] = useState();
    const [visibleMovies, setVisibleMovies] = useState(20);
    const [ loading, setLoading ] = useState(true);
    const [ idioma, setIdioma ] = useState();

    useEffect(()=> {
        setQualidadeImg(localStorage.getItem('qualidadeImg'));
        setIdioma(localStorage.getItem('idioma'));
    }, []);

    useEffect(()=> {
        setVisibleMovies(20);

        if (movies && movies?.length < 19) {
            setLoading(true);
        }

        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [ movies, mediaType ]);
    
    function verificaDataRecente(data) {
        const dataFormatada = new Date(data);
        const dataAtual = new Date();
        const limiteTempo = 1000 * 60 * 60 * 24 * 14; // 2 semanas em milissegundos
    
        if (dataFormatada instanceof Date && !isNaN(dataFormatada)) {
            if (dataAtual - dataFormatada <= limiteTempo) {
                if (dataFormatada > dataAtual) {
                    return 'will';
                } else {
                    return 'new';
                }
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }

    return(
        <div className="content-movies">
            {loading ?
                <div className="content-movies-tmdb">
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                    <div className="movie-loading"></div>
                </div>
            :
                <div>
                    {(movies && movies?.length >=1) &&
                        <>
                            <div className="content-movies-tmdb">
                                {movies?.map((movie, key)=> {
                                    return (
                                        <a href={`https://moovweb.netlify.app/preview/${movie?.media_type}/${movie?.id}`} target="_blank" className="movie-tmdb" key={key}>
                                            <div className="content-movie-tmdb">
                                                <section className="section-img-movie-tmdb">
                                                    <img src={`https://image.tmdb.org/t/p/w200${movie?.profile_path ? movie?.profile_path : movie?.poster_path}`} loading="lazy" alt={movie?.title ? movie?.title : movie?.name} onError={({ currentTarget }) => {currentTarget.onerror = null; currentTarget.src="https://dflix.netlify.app/imagens/img-erro-exclamacao.png";}}/>
                                                </section>
                                                <section>
                                                    <header className="header-movie-tmdb">
                                                        <span className="type-movie-tmdb">{movie?.media_type === 'tv' ? "Série / tv" : "Filme"}</span>
                                                        {verificaDataRecente(movie?.release_date ? movie?.release_date : movie?.first_air_date) &&
                                                            <span className="span-new">{(verificaDataRecente(movie?.release_date ? movie?.release_date : movie?.first_air_date) == 'will' ? movie?.release_date ? `Em breve` : movie?.first_air_date : (verificaDataRecente(movie?.release_date ? movie?.release_date : movie?.first_air_date) == 'new' ? 'Novo' : ''))}</span>
                                                        }
                                                    </header>
                                                    {movie?.character &&
                                                        <span className="character-people-movie"><i className="fa-solid fa-user"></i> {movie?.character} {movie?.episode_count && `| ${movie?.episode_count} Episódio${movie?.episode_count > 1 ? 's' : ''}`}</span>
                                                    }
                                                    <h2>{movie?.title ? movie?.title : movie?.name}</h2>
                                                    {(movie?.first_air_date || movie?.release_date || movie?.vote_average && movie?.vote_average > 0) &&
                                                        <section className="section-info-movie-tmdb">
                                                            {(movie?.first_air_date || movie?.release_date) &&
                                                                <span>
                                                                    {(movie?.first_air_date && movie?.first_air_date.slice(0,4)) || (movie?.release_date && movie?.release_date.slice(0,4))}
                                                                </span>
                                                            }
                                                            {movie?.vote_average > 0 &&
                                                                <span><small><i className="fa-solid fa-star"></i></small>{movie?.vote_average.toFixed(1)}</span>
                                                            }
                                                        </section>
                                                    }
                                                    {movie?.overview &&
                                                        <section>
                                                            <p className="overview-movie-tmdb">{movie?.overview}</p>
                                                        </section>
                                                    }
                                                    <section className="known-for-suggestion-search-movie">
                                                        {(movie?.known_for && movie?.known_for.length >= 1) &&
                                                            movie?.known_for.slice(0,3).map((know, key)=>{
                                                                return(
                                                                    <p className="type-movie-tmdb known-for-suggestion-search" key={key}>&nbsp;&bull; {know.name ? know.name : know.title}</p>
                                                                )
                                                            })
                                                        }
                                                    </section>
                                                </section>
                                            </div>
                                            {((key + 1) <= 99 && showIndex) &&
                                                <div className="div-index-movies-trending">
                                                    <span>{Number(key + 1)}</span>
                                                </div>
                                            }
                                        </a>
                                    )
                                })}
                            </div>
                        </>
                    }
                </div>
            }
        </div>
    )
}

export default MovieTmdb;